/*
 * ms-zusatzleistungen.js · Messe-Shop24
 * Zusatzleistungen (erweiterter Datencheck, Formatanpassung, Lanyard-Andruckmuster)
 * als verknüpfte Unterposition (nested cart line) am Produkt.
 *
 * - Produktseite: Auswahl in snippets/ms-zusatzleistungen.liquid
 *   product-form.js ruft nach erfolgreichem Hinzufügen window.msZusatz.nachHinzufuegen() auf.
 * - Warenkorb/Drawer: Buttons [data-mszl-add] aus snippets/cart-items.liquid
 */
(function () {
  if (window.msZusatz) return;

  const routes = (window.theme && window.theme.routes) || {};
  const CART = routes.cart || '/cart';
  const CART_ADD = routes.cartAdd || '/cart/add';

  const box = (productId) => document.querySelector(`[data-mszl][data-product-id="${productId}"]`);

  /** Gewählte Leistungs-Variante einer Box oder null. */
  function gewaehlt(b) {
    if (!b || ohneDruck(b)) return null;
    if (b.dataset.stufe === 'Lanyard') {
      const am = b.querySelector('[data-mszl-am]');
      return am && am.checked ? { id: b.dataset.am, name: 'Andruckmuster inkl. Versand' } : null;
    }
    const opt = b.querySelector('input[type="radio"]:checked');
    const wert = opt ? opt.value : 'eigen';
    if (wert === 'fa' && b.dataset.fa) return { id: b.dataset.fa, name: 'Formatanpassung' };
    if (wert === 'eigen') {
      const dc = b.querySelector('[data-mszl-dc]');
      if (dc && dc.checked && b.dataset.dc) return { id: b.dataset.dc, name: 'Erweiterter Datencheck' };
    }
    return null;
  }


  /** „In den Warenkorb“ bei Neugestaltung sperren (nur Buttons, die wir selbst gesperrt haben, wieder freigeben). */
  function warenkorbButtons(b) {
    const form = document.querySelector('form.js-product-form-main');
    if (!form) return [];
    const btns = Array.from(form.querySelectorAll('[name="add"], .shopify-payment-button button'));
    if (form.id) btns.push(...document.querySelectorAll(`[form="${form.id}"][name="add"]`));
    document.querySelectorAll('sticky-atc-panel [name="add"], .sticky-atc [name="add"]').forEach((el) => btns.push(el));
    return btns;
  }
  function atcSperren(b, sperren) {
    warenkorbButtons(b).forEach((btn) => {
      if (sperren) {
        if (btn.dataset.mszlGesperrt) return;
        btn.dataset.mszlGesperrt = '1';
        btn.dataset.mszlAriaVorher = btn.getAttribute('aria-disabled') || '';
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('title', 'Neugestaltung läuft über ein Angebot, nicht über den Warenkorb');
        btn.classList.add('mszl-atc-gesperrt');
      } else if (btn.dataset.mszlGesperrt) {
        const vorher = btn.dataset.mszlAriaVorher;
        if (vorher) btn.setAttribute('aria-disabled', vorher); else btn.removeAttribute('aria-disabled');
        btn.removeAttribute('title');
        btn.classList.remove('mszl-atc-gesperrt');
        delete btn.dataset.mszlGesperrt;
        delete btn.dataset.mszlAriaVorher;
      }
    });
  }


  function aktuelleVariante() {
    const form = document.querySelector('form.js-product-form-main');
    const id = form && form.querySelector('[name="id"]');
    return id ? String(id.value) : '';
  }
  function ohneDruck(b) {
    const liste = b.dataset.ohneDruck || '';
    const v = aktuelleVariante();
    return !!v && liste.indexOf(`,${v},`) !== -1;
  }


  /** Druckdatenblatt-Link(s) der gewählten Variante aktualisieren. */
  function datenblattAktualisieren(b) {
    const box = b.querySelector('[data-mszl-dd]');
    const daten = b.querySelector('[data-mszl-dd-map]');
    if (!box || !daten) return;
    let map = {};
    try { map = JSON.parse(daten.textContent); } catch (e) { return; }
    const urls = (map[aktuelleVariante()] || []).filter(Boolean);
    const icon = box.querySelector('a svg');
    const iconHtml = icon ? icon.outerHTML : '';
    box.innerHTML = urls.map((u, i) => `<a href="${u}" target="_blank" rel="noopener">${iconHtml}Druckdatenblatt${urls.length > 1 ? ` Teil ${i + 1}` : ''}</a>`).join('');
    box.hidden = urls.length === 0;
  }

  function preisText(label) {
    const el = label && label.querySelector('.mszl__preis');
    return el ? el.firstChild.textContent.trim() : '';
  }

  /** Box-Zustand aktualisieren (Sichtbarkeit, Zusammenfassung). */
  function aktualisieren(b) {
    const aus = ohneDruck(b);
    b.classList.toggle('mszl--aus', aus);
    const ausText = b.querySelector('[data-mszl-aus-text]');
    if (ausText) ausText.hidden = !aus;
    if (aus) {
      const eigen = b.querySelector('input[value="eigen"]');
      if (eigen) eigen.checked = true;
      b.querySelectorAll('input[type="checkbox"]').forEach((c) => { c.checked = false; });
    }
    const opt = b.querySelector('input[type="radio"]:checked');
    const wert = opt ? opt.value : null;
    const dcWrap = b.querySelector('[data-mszl-dc-wrap]');
    if (dcWrap) {
      dcWrap.hidden = wert !== 'eigen';
      if (wert !== 'eigen') dcWrap.querySelector('input').checked = false;
    }
    const neu = b.querySelector('[data-mszl-neu]');
    if (neu) neu.hidden = wert !== 'neu';
    atcSperren(b, wert === 'neu');
    const hinweis = b.querySelector('[data-mszl-grafik-hinweis]');
    if (hinweis) hinweis.hidden = !(wert === 'fa' || wert === 'neu');

    const summe = b.querySelector('[data-mszl-summe]');
    const auswahl = gewaehlt(b);
    if (!summe) return;
    if (wert === 'neu') {
      summe.textContent = 'Neugestaltung auf Angebot';
    } else if (auswahl) {
      let label = null;
      if (auswahl.id === b.dataset.dc) label = b.querySelector('[data-mszl-dc-wrap]');
      else if (auswahl.id === b.dataset.am) label = b.querySelector('[data-mszl-am]').closest('label');
      else label = b.querySelector('input[value="fa"]').closest('label');
      summe.textContent = `${auswahl.name} ${preisText(label)}`;
    } else {
      summe.textContent = 'ohne Zusatzleistung';
    }
  }

  function fehler(b, text) {
    const el = b && b.querySelector('[data-mszl-fehler]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  async function hinzufuegen(variantId, parentKey, titel, sections) {
    const body = {
      items: [{
        id: Number(variantId),
        quantity: 1,
        parent_line_key: parentKey,
        properties: { 'Für Artikel': titel }
      }]
    };
    if (sections) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }
    const res = await fetch(`${CART_ADD}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || res.status);
    return json;
  }


  /** Aktuell gewählte Variante und Menge des Produktformulars in die Anfrage übernehmen. */
  function produktUebernehmen(d) {
    const daten = d.querySelector('[data-mszl-varianten]');
    const form = document.querySelector('form.js-product-form-main');
    if (!daten || !form) return;
    let map = {};
    try { map = JSON.parse(daten.textContent); } catch (e) { return; }
    const idFeld = form.querySelector('[name="id"]');
    const v = idFeld && map[idFeld.value];
    const mengeFeld = form.elements.namedItem('quantity') || document.querySelector(`[name="quantity"][form="${form.id}"]`);
    const menge = mengeFeld && mengeFeld.value ? mengeFeld.value : '1';
    const setze = (sel, wert, attr) => { const el = d.querySelector(sel); if (el) { if (attr) el.value = wert; else el.textContent = wert; } };
    if (v) {
      const variante = v.t === 'Default Title' ? '' : v.t;
      setze('[data-mszl-p-variante]', variante);
      setze('[data-mszl-f-variante]', variante, true);
      setze('[data-mszl-p-sku]', v.s || '–');
      setze('[data-mszl-f-sku]', v.s || '', true);
      setze('[data-mszl-f-link]', v.u, true);
    }
    setze('[data-mszl-p-menge]', menge);
    setze('[data-mszl-f-menge]', menge, true);
  }


  /** Warenkorb-Seite und Drawer neu rendern. */
  function warenkorbNeuLaden() {
    const drawer = document.querySelector('cart-drawer');
    const seite = window.location.pathname === CART
      ? Array.from(document.querySelectorAll('cart-items')).find((el) => !el.closest('cart-drawer'))
      : null;
    if (seite && typeof seite.refreshCartItems === 'function') seite.refreshCartItems();
    if (drawer && typeof drawer.refreshCartDrawer === 'function') drawer.refreshCartDrawer();
    if (!drawer && !seite) window.location.reload();
  }

  window.msZusatz = {
    /**
     * Hängt nach dem Hinzufügen des Produkts die gewählte Leistung an.
     * @param {object} data – Antwort von /cart/add (einzelne Position)
     * @param {string} sections – Section-IDs wie im Theme-Request
     * @returns {object|null} Antwort mit neuen Sections oder null
     */
    async nachHinzufuegen(data, sections) {
      const b = box(data.product_id);
      const auswahl = gewaehlt(b);
      if (!auswahl || !data.key) return null;
      fehler(b, '');
      try {
        const cart = await (await fetch(`${CART}.js`)).json();
        const schonDa = cart.items.some((i) => i.parent_relationship
          && i.parent_relationship.parent_key === data.key
          && String(i.variant_id) === String(auswahl.id));
        if (schonDa) return null;
        const titel = data.product_title + (data.variant_title ? ` – ${data.variant_title}` : '');
        return await hinzufuegen(auswahl.id, data.key, titel, sections);
      } catch (e) {
        fehler(b, `Das Produkt liegt im Warenkorb, die Zusatzleistung konnte aber nicht hinzugefügt werden (${e.message}). Du kannst sie im Warenkorb nachtragen.`);
        return null;
      }
    }
  };

  document.addEventListener('submit', (e) => {
    if (!e.target.matches || !e.target.matches('form.js-product-form-main')) return;
    const b = document.querySelector('[data-mszl]');
    const opt = b && b.querySelector('input[type="radio"]:checked');
    if (opt && opt.value === 'neu') { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // Produktseite: Änderungen und Anfrage-Dialog
  document.addEventListener('change', (e) => {
    const b = e.target.closest('[data-mszl]');
    if (b) aktualisieren(b);
  });

  document.addEventListener('click', async (e) => {
    const anfrage = e.target.closest('[data-mszl-anfrage]');
    if (anfrage) {
      const b = anfrage.closest('[data-mszl]');
      const d = b && document.getElementById(`${b.id}-dialog`);
      if (d) produktUebernehmen(d);
      if (d && typeof d.showModal === 'function') d.showModal();
      return;
    }
    const zu = e.target.closest('[data-mszl-zu]');
    if (zu) { zu.closest('dialog').close(); return; }

    // Warenkorb: Anzahl einer Zusatzleistung ändern (pro Motiv)
    const qty = e.target.closest('[data-mszl-qty]');
    if (qty) {
      e.preventDefault();
      qty.disabled = true;
      try {
        const res = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(qty.dataset.line), quantity: Number(qty.dataset.qty) })
        });
        if (!res.ok) throw new Error(res.status);
      } catch (err) { console.log(err); } // eslint-disable-line
      warenkorbNeuLaden();
      return;
    }

    // Warenkorb: Zusatzleistung nachträglich hinzufügen
    const add = e.target.closest('[data-mszl-add]');
    if (!add) return;
    e.preventDefault();
    add.disabled = true;
    add.classList.add('is-loading');
    try {
      await hinzufuegen(add.dataset.variant, add.dataset.parentKey, add.dataset.titel);
      warenkorbNeuLaden();
    } catch (err) {
      add.disabled = false;
      add.classList.remove('is-loading');
      add.insertAdjacentHTML('afterend', `<span class="mszl-cart__fehler">${err.message}</span>`);
    }
  });

  document.addEventListener('on:variant:change', () => {
    setTimeout(() => {
      document.querySelectorAll('[data-mszl]').forEach((b) => {
        aktualisieren(b);
        datenblattAktualisieren(b);
        const opt = b.querySelector('input[type="radio"]:checked');
        if (opt && opt.value === 'neu') {
          warenkorbButtons(b).forEach((btn) => { delete btn.dataset.mszlGesperrt; });
          atcSperren(b, true);
        }
      });
    }, 50);
  });

  function init() {
    document.querySelectorAll('[data-mszl]').forEach((b) => {
      aktualisieren(b);
      // Nach Absenden der Anfrage: Dialog nur für dieses Formular wieder öffnen
      if (window.location.hash === '#mszl-anfrage-form') {
        const d = document.getElementById(`${b.id}-dialog`);
        if (d && d.querySelector('[data-mszl-auf]') && typeof d.showModal === 'function') d.showModal();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
